var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:['btn btn-success add-to-cart', {disabled: _vm.isDisabled}],attrs:{"disabled":_vm.isDisabled,"href":"#"},on:{"click":function($event){_vm.submit()}}},[_vm._v(_vm._s(_vm.btnText)),_c('i',{staticClass:"fa fa-cart-plus ml-2"})])}
var staticRenderFns = []

export { render, staticRenderFns }